<template>
  <div>
    <v-layout row wrap py-2>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon color="secondary">layers</v-icon>
            <span>&ensp;</span>
            <h3>{{ $t('title.cluster') }}</h3>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>ID</strong>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="items.id" disabled class="pt-0"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>
                    <span class="red--text">*</span>
                    {{ $t('items.name') }}
                  </strong>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    autofocus
                    v-model="items.name"
                    :rules="[
                      v => !!v || $t('rules.required'),
                      // v => /^[a-zA-Z0-9-_]+$/.test(v) || $t('rules.unusable'),
                      v => v.length <= 45 || $t('rules.max45c')
                    ]"
                    counter="45"
                    class="pt-0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="pb-2">
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>{{ $t('items.parent') }}</strong>
                </v-flex>
                <v-flex xs6>
                  <v-select
                    :items="parants"
                    item-text="name"
                    item-value="id"
                    v-model="items.parent_id"
                    class="pt-0"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row class="pb-2">
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>
                    <span class="red--text">*</span>
                    {{ $t('items.tag') }}
                  </strong>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="items.tag"
                    :rules="[
                      v => !!v || $t('rules.required'),
                      v => v.length <= 45 || $t('rules.max45c')
                    ]"
                    counter="45"
                    class="pt-0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>{{ $t('items.image') }}</strong>
                </v-flex>
                <v-flex xs6>
                  <div
                    @click.stop="onPickFile"
                    @dragover.prevent
                    @drop.prevent="onDropFile"
                    :class="[
                      'image-box',
                      error ? 'size' : ''
                    ]"
                  >
                    <span class="caption grey--text" v-if="!image">{{ $t('discriptions.image') }}</span>
                    <img :src="image" alt class="image">
                    <br>
                    <v-btn
                      outline
                      small
                      color="error"
                      @click.stop="onRemoveFile"
                      v-if="image"
                    >{{ $t('common.remove') }}</v-btn>
                    <input type="file" ref="file" accept="image/*" @change="onChangeFile">
                  </div>
                  <span class="caption error--text" v-if="error">{{ message }}</span>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>{{ $t('items.cm_per_pixel') }}</strong>
                </v-flex>
                <v-flex xs2>
                  <v-text-field
                    v-model="items.cm_per_pixel"
                    :rules="[
                      v => v >= 0 || $t('rules.min0n'),
                      v => !v || /^[\d+(\.\d+)?]+$/.test(v) || $t('rules.unusable')
                    ]"
                    suffix="cm"
                    class="pt-0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>{{ $t('items.att_coef') }}</strong>
                </v-flex>
                <v-flex xs2>
                  <v-text-field
                    v-model="items.att_coef"
                    :rules="[
                      v => v >= 0 || $t('rules.min0n'),
                      v => !v || /^[\d+(\.\d+)?]+$/.test(v) || $t('rules.unusable')
                    ]"
                    class="pt-0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>{{ $t('items.status') }}</strong>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox style="margin-top: 3px;" v-model="items.enabled" disabled></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row class="content-center">
                <v-flex xs5 class="draggable-wrap small">
                  <v-text-field
                    v-model="beaconSearch"
                    label="絞り込み条件"
                    outlined
                    append-icon="search"
                    @click:append="onSearchBeacon"
                  />
                  <v-checkbox
                    v-model="checkAll"
                    label="全てチェック"
                    hide-details
                    @change="toggleAll"
                  />
                  <div
                    class="draggable-area small"
                    ref="scrollContainerBeacon"
                    @scroll="handleScrollBeacon"
                  >
                    <div
                      class="virtual-list-total"
                      :style="{ height: (filteredBeacons ? filteredBeacons.length : 0) * ITEM_HEIGHT + 'px' }"
                    >
                      <div
                        class="virtual-list-visible"
                        :style="{ transform: 'translateY(' + beaconStartIndex * ITEM_HEIGHT + 'px)' }"
                      >
                        <beacon-draggable
                          v-for="(beacon, i) in visibleBeacon"
                          :key="beacon.id"
                          :beacon="beacon"
                          :index="beaconStartIndex + i"
                          :apps="apps"
                          :user="user"
                          :checked.sync="beacon.checked"
                           @show-info="openInfoDialog"
                        />
                        <BeaconInfo
                          v-if="selectedBeaconInfo"
                          v-model="showBeaconInfo"
                          :beacon="selectedBeaconInfo"
                        />
                        <DeviceInfo
                          v-if="selectedDeviceInfo"
                          v-model="showDeviceInfo"
                          :device="selectedDeviceInfo"
                        />
                      </div>
                    </div>
                  </div>

                </v-flex>
                <v-flex class="d-flex flex-column align-center justify-center">
                    <v-btn outline color="secondary" class="fill-available"  @click="addToSelectedBeacons">チェックした物を入れる  ＞</v-btn>
                    <v-btn outline color="secondary" class="fill-available" @click="removeSelectedBeacons">＜　  チェックした物を外す</v-btn>
                </v-flex>
                <v-flex xs5 class="draggable-wrap small">
                  <v-text-field
                    v-model="selectedSearch"
                    label="絞り込み条件"
                    outlined
                    append-icon="search"
                    @click:append="onSearchSelected"
                  />
                  <v-checkbox
                    v-model="checkAllSelected"
                    label="全てチェック"
                    hide-details
                    @change="toggleAllSelected"
                  />
                  <div
                    class="draggable-area destination small"
                    ref="scrollContainerSelected"
                    @scroll="handleScrollSelected"
                  >
                    <div
                      class="virtual-list-total"
                      :style="{ height: (filteredSelectedBeacons ? filteredSelectedBeacons.length : 0) * ITEM_HEIGHT + 'px' }"
                    >
                      <div
                        class="virtual-list-visible"
                        :style="{ transform: 'translateY(' + selectedStartIndex * ITEM_HEIGHT + 'px)' }"
                      >
                        <selected-beacon-draggable
                          v-for="(item, i) in visibleSelectedBeacon"
                          :key="item.id"
                          :item="item"
                          :index="selectedStartIndex + i"
                          :apps="apps"
                          :user="user"
                          :items="items"
                          :image="image"
                          :onFilterBeacons="onFilterBeacons"
                          :checked.sync="item.checked"
                        />
                      </div>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn outline color="secondary" @click.stop="$router.go(-1)">{{ $t('common.back') }}</v-btn>
            <v-spacer></v-spacer>
            <add-beacon-to-cluster-confirmation
              :dialog="checkAddBeaconList.length > 0"
              @okAction="moveBeacon"
              :beacons="[...checkAddBeaconList,...checkConflictingBeaconList]"
              @cancelAction="cancelMoveBeacon"
            ></add-beacon-to-cluster-confirmation>
            <conflicting-beacon-to-cluster-confirmation
              :dialog="checkConflictingBeaconList.length > 0 && checkConflictBeacon"
              :beacons="checkConflictingBeaconList"
              @okAction="confirmConflictBeacon"
            ></conflicting-beacon-to-cluster-confirmation>
            <save-confirmation v-on:onSave="onSave" :valid="valid" :loading="loading"></save-confirmation>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import uuid from "uuid";
import { mapState, mapActions } from "vuex";
import ColorFilter from "../../utils/filters/ColorFilter";
import ImageMethod from "../../utils/methods/ImageMethod";
import ClusterMethod from "../../utils/methods/ClusterMethod";
import SaveConfirmation from "../../components/dialogs/SaveConfirmation";
import AddBeaconToClusterConfirmation from "../../components/dialogs/AddBeaconToClusterConfirmation";
import ConflictingBeaconToClusterConfirmation from "../../components/dialogs/ConflictingBeaconToClusterConfirmation";
import virtualList from 'vue-virtual-draglist';
import BeaconDraggable from "./BeaconDraggable";
import SelectedBeaconDraggable from "./SelectedBeaconDraggable";
import BeaconInfo from "./BeaconInfo.vue";
import DeviceInfo from "./DeviceInfo.vue";

export default {
  data() {
    return {
      sharedState: {
        editmode: false
      },
      valid: false,
      loading: false,
      items: {
        id: uuid(),
        client_id: "",
        name: "",
        tag: "",
        image: "",
        cm_per_pixel: null,
        att_coef: "2.0",
        parent_id: "",
        enabled: true,
        beacons: []
      },
        checkAddBeaconIndex: null,
        checkConflictingBeaconIndex: null,
        confirmedAppLimits: [],
        apps: [],
        group: { name: 'group', pull: true, put: true },
        bottomLoad: true,
        beacons: [],
        selectedStartIndex: 0,
        beaconStartIndex: 0,
        visibleCount: 15,
        ITEM_HEIGHT: 72,
        visibleSelectedBeacon: [],
        visibleBeacon: [],
        checkAllSelected: false,
        checkAll: false,
        beaconSearch: '',
        filteredBeacons: [],
        selectedSearch: '',
        filteredSelectedBeacons: [],
        checkAddBeaconList: [],
        checkConflictBeacon: false,
        checkConflictingBeaconList: [],
        showBeaconInfo: false,
        selectedBeaconInfo: null,
        showDeviceInfo: false,
        selectedDeviceInfo: null,
    };
  },
  components: {
    ConflictingBeaconToClusterConfirmation,
    AddBeaconToClusterConfirmation,
    SaveConfirmation,
    virtualList,
    BeaconDraggable,
    SelectedBeaconDraggable,
    BeaconInfo,
    DeviceInfo
  },
  provide() {
    return {
      sharedState: this.sharedState
    }
  },
  computed: {
    remainingBeaconsCount() {
      return this.beacons.length;
    },
    ...mapState(["user"]),
    handleDataItem() {
      let data = {...this.items};
      let arrBeacons = data.beacons.filter((item) => item.type === "beacon");
      let arrDevices = data.beacons.filter((item) => item.type === "device");
      data.beacons = arrBeacons.map(({ type, ...beacon }) => beacon);
      data.devices = arrDevices.map(({ type, ...device }) => device);
      return data;
    },
  },
  mounted() {
    this.onFetchParents();
    this.onFetchApps();

    this.onFetchBeaconsAndDevices().then(() => {
        this.filteredBeacons = [...this.beacons].sort((a, b) => a.type === b.type ? a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }) : a.type === 'beacon' ? -1 : 1);
        this.updateBeaconVisible();
    });
  },
  methods: {
    onFetchApps() {
        axios
            .get("/apps", {
                params: {
                    client_id: this.$route.params.id,
                    per_page: 1000,
                    page: 1
                }
            })
            .then(response => {
                if (response.data.code === 200) {
                    const apps = response.data.payload.hits;
                    this.apps = apps.map(app => app.id);
                } else {
                }
            });
    },
    cancelMoveBeacon() {
      this.checkAddBeaconList = [];
      this.checkConflictingBeaconList = [];
      this.confirmedAppLimits = this.items.beacons.reduce(
        (t, b) => [...t, ...(b.shared_app_id || [])],
        []
      );

      this.checkConflictBeacon = false;
    },
    moveBeacon() {
      if (!this.validateMobileBeaconClusterTag(this.checkAddBeaconList, this.items.tag)) {
        this.cancelMoveBeacon();
        return;
      }

      if (this.checkAddBeaconList.length) {
        this.checkAddBeaconList.forEach(b => (b.checked = false));
        
        this.beacons = this.beacons.filter(b => !this.checkAddBeaconList.includes(b));
        this.filteredBeacons = this.filteredBeacons.filter(b => !this.checkAddBeaconList.includes(b));
        this.updateBeaconVisible();

        this.filteredSelectedBeacons.push(
          ...this.checkAddBeaconList.map(b => ({ ...b }))
        );

        this.filteredSelectedBeacons = this.filteredSelectedBeacons.sort((a, b) => a.type === b.type ? a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }) : a.type === 'beacon' ? -1 : 1);
        this.items.beacons.push(...this.checkAddBeaconList.map(b => ({ ...b })));
        this.updateSelectedVisible();
      }

      this.checkAddBeaconList = [];
      this.checkConflictBeacon = this.checkConflictingBeaconList.length > 0
    },
    confirmConflictBeacon() {
      this.checkConflictingBeaconList = [];
      this.checkConflictBeacon = false;
    },
    checkCanDrop(evt) {
        if('added' in evt) {
            // add shared beacons with alert
            if(evt.added.element.shared && evt.added.element.client_id !== this.user.client_id) {
                // if beacon with single app being registered, beacon with same single app can be registered, or if beacon with multiple apps includes the single app that being registered
                const existSingleApp = this.confirmedAppLimits.length === 1 && evt.added.element.shared_app_id.filter(x => this.confirmedAppLimits.includes(x)).length > 0;

                // if beacon with multiple apps being registered, only beacon with same multiple apps can be registered
                const filter_clients_shared_apps = evt.added.element.shared_app_id.filter(x => this.apps.includes(x)).length > 0 ? evt.added.element.shared_app_id.filter(x => this.apps.includes(x)) : [];
                const filter_clients_shared_apps_string = filter_clients_shared_apps.sort().join(',');
                const existMultipleApps = this.confirmedAppLimits.length  > 1 && filter_clients_shared_apps_string === this.confirmedAppLimits.sort().join(',');
                if(this.confirmedAppLimits.length == 0){
                    this.checkAddBeaconIndex = evt.added;
                    this.confirmedAppLimits = evt.added.element.shared_app_id.filter(x => this.apps.includes(x)).length > 0 ? evt.added.element.shared_app_id.filter(x => this.apps.includes(x)) : [];
                }else{
                  if(!existSingleApp && !existMultipleApps) {
                      // conflicted app
                      this.checkConflictingBeaconIndex = evt.added;
                      this.items.beacons.splice(evt.added.newIndex, 1);
                  } else {
                      this.beacons.splice(evt.added.element.prevIndex, 1)
                  }
                }
            }
            // add owners's own beacon
            else {
                this.beacons.splice(evt.added.element.prevIndex, 1)
            }
        }
    },
    checkCanRemove(evt) {
        if('added' in evt) {
            if(evt.added.element.shared) {
                this.checkRemoveBeaconIndex = evt.added;
                this.confirmedAppLimits = [...this.items.beacons].splice(evt.added.element.prevIndex, 1).reduce((t,b) => [...t, ...b.shared_app_id || []], []);
            }
            this.beacons.splice(evt.added.newIndex, 0, evt.added.element)
        }
    },
    handleScrollSelected(event) {
      const element = event.target;
      const scrollTop = element.scrollTop;
      const newStartIndex = Math.floor(scrollTop / this.ITEM_HEIGHT);

      if (newStartIndex !== this.selectedStartIndex) {
        this.selectedStartIndex = newStartIndex;
        this.updateSelectedVisible();
      }
    },
    handleScrollBeacon(event) {
      const element = event.target;
      const scrollTop = element.scrollTop;
      const newStartIndex = Math.floor(scrollTop / this.ITEM_HEIGHT);

      if (newStartIndex !== this.beaconStartIndex) {
        this.beaconStartIndex = newStartIndex;
        this.updateBeaconVisible();
      }
    },
    updateSelectedVisible() {
      const endIndex = this.selectedStartIndex + this.visibleCount;
      this.visibleSelectedBeacon = this.filteredSelectedBeacons ? this.filteredSelectedBeacons.slice(this.selectedStartIndex, endIndex) : [];
    },
    updateBeaconVisible() {
      const endIndex = this.beaconStartIndex + this.visibleCount;
      this.visibleBeacon = this.filteredBeacons.slice(this.beaconStartIndex, endIndex);
    },
    toggleAllSelected() {
      this.filteredSelectedBeacons.forEach(item => {
        this.$set(item, "checked", this.checkAllSelected);
      });
    },
    toggleAll() {
      this.filteredBeacons.forEach(item => {
        this.$set(item, "checked", this.checkAll);
      });
    },
    onSearchBeacon() {
      const searchTerm = this.beaconSearch.trim().toLowerCase();

      if (!searchTerm) {
        this.filteredBeacons = [...this.beacons].sort((a, b) => a.type === b.type ? a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }) : a.type === 'beacon' ? -1 : 1);
      } else {
        this.filteredBeacons = [...this.beacons]
        .filter(beacon => beacon.name.toLowerCase().includes(searchTerm))
        .sort((a, b) => a.type === b.type ? a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }) : a.type === 'beacon' ? -1 : 1);
      }

      this.beaconStartIndex = 0;
      this.updateBeaconVisible();

      this.$nextTick(() => {
        const container = this.$refs.scrollContainerBeacon;
        if (container) container.scrollTop = 0;
      });

      this.checkAll = false;
      this.toggleAll();
    },
    onSearchSelected() {
      const searchTerm = this.selectedSearch.trim().toLowerCase();

      if (!searchTerm) {
        this.filteredSelectedBeacons = [...this.items.beacons].sort((a, b) => a.type === b.type ? a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }) : a.type === 'beacon' ? -1 : 1);
      } else {
        this.filteredSelectedBeacons = [...this.items.beacons]
        .filter(beacon => beacon.name.toLowerCase().includes(searchTerm))
        .sort((a, b) => a.type === b.type ? a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }) : a.type === 'beacon' ? -1 : 1);
      }

      this.selectedStartIndex = 0;
      this.updateSelectedVisible();

      this.$nextTick(() => {
        const container = this.$refs.scrollContainerSelected;
        if (container) container.scrollTop = 0;
      });

      this.checkAllSelected = false;
      this.toggleAllSelected();
    },
    addToSelectedBeacons() {
      const selected = this.filteredBeacons.filter(b => b.checked);
        if (!selected.length) return;
        if (!this.validateMobileBeaconClusterTag(selected, this.items.tag)) return;

        const normalBeacons = [];

        for (const b of selected) {
          if (b.shared && b.client_id !== this.user.client_id) {
            const filter_clients_shared_apps = b.shared_app_id.filter(x => this.apps.includes(x));
            const existSharedApp =
              this.confirmedAppLimits.length > 0 &&
              filter_clients_shared_apps.some(x => this.confirmedAppLimits.includes(x));

            if (this.confirmedAppLimits.length === 0) {
              this.checkAddBeaconList.push(b);
              this.confirmedAppLimits = filter_clients_shared_apps;
            } else {
              if (!existSharedApp) {
                this.checkConflictingBeaconList.push(b);
              } else {
                this.checkAddBeaconList.push(b);
                this.confirmedAppLimits = this.confirmedAppLimits.filter(x =>
                  filter_clients_shared_apps.includes(x)
                );
              }
            }
          } else {
            normalBeacons.push(b);
          }
        }

        if (this.checkAddBeaconList.length == 0 && this.checkConflictingBeaconList.length > 0) {
          this.checkConflictBeacon = true;
        }

        normalBeacons.forEach(b => (b.checked = false));
        const normalBeaconIds = new Set(normalBeacons.map(b => b.id));

        this.beacons = this.beacons.filter(b => !normalBeaconIds.has(b.id));
        this.filteredBeacons = this.filteredBeacons.filter(b => !normalBeacons.includes(b));
        this.updateBeaconVisible();

        if (normalBeacons.length) {
          this.filteredSelectedBeacons.push(...normalBeacons.map(b => ({ ...b })));
          this.filteredSelectedBeacons = this.filteredSelectedBeacons.sort((a, b) => a.type === b.type ? a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }) : a.type === 'beacon' ? -1 : 1);
          this.items.beacons.push(...normalBeacons.map(b => ({ ...b })));
          this.updateSelectedVisible();
        }

        this.checkAll = false;  
    },

    removeSelectedBeacons() {
      const selected = this.filteredSelectedBeacons.filter(b => b.checked);
        if (!selected.length) return;

        selected.forEach(b => (b.checked = false));
        const selectedIds = new Set(selected.map(b => b.id));

        this.items.beacons = this.items.beacons.filter(b => !selectedIds.has(b.id));

        this.filteredSelectedBeacons = this.filteredSelectedBeacons.filter(b => !selected.includes(b));
        this.updateSelectedVisible();

        this.filteredBeacons.push(...selected.map(b => ({ ...b })));
        this.filteredBeacons = this.filteredBeacons.sort((a, b) => a.type === b.type ? a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }) : a.type === 'beacon' ? -1 : 1);

        this.beacons.push(...selected.map(b => ({ ...b })));
        this.updateBeaconVisible();

        this.confirmedAppLimits = this.items.beacons.reduce(
          (t, b) => [...t, ...(b.shared_app_id || [])],
          []
        );

        this.checkAllSelected = false;
    },
    openInfoDialog(beacon) {
      if (beacon.type == 'beacon') {
        this.selectedBeaconInfo = beacon;
        this.showBeaconInfo = true;
      }
      if (beacon.type == 'device') {
        this.selectedDeviceInfo = beacon;
        this.showDeviceInfo = true;
      }
    },
    ...mapActions(["onNotify"]),
    onSave() {
      if (!this.validateMobileBeaconClusterTag()) return;

      this.loading = true;
      let path = this.$route.path.replace(/\/new/g, "");
      axios.post(path, this.handleDataItem).then(response => {
        if (response.data.code === 200) {
          setTimeout(() => {
            this.loading = false;
            this.$router.go(-1);
            this.onNotify({
              type: "success",
              text: "Creating Successfully!"
            });
          }, 1000);
        } else {
          this.loading = false;
        }
      }).catch(error => {
        this.loading = false;

        this.onNotify({
          type: "error",
          text: this.getClusterSaveErrorMessage(error),
          multiLine: true
        });
      });
    }
  },
  mixins: [ColorFilter, ImageMethod, ClusterMethod]
};
</script>

<style scoped>
.draggable-area.small {
  height: 800px !important;
  overflow-y: auto;
}
.virtual-list-total {
  position: relative;
  width: 100%;
}
.virtual-list-visible {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.content-center {
  align-items: center;
}
.flex-column {
  flex-direction: column;
}
.fill-available {
  width: -webkit-fill-available;
}
</style>
